// extracted by mini-css-extract-plugin
module.exports = {"title":"style-module--title--z9Gvu","item":"style-module--item--3YKEt","label":"style-module--label--ytmzw"};